export default __webpack_public_path__ + "static/media/avatar_6.c41c9269.svg";